<template>
    <div
        class="guestflip-item-wrapper">
        <div class="row guestflip-item mx-0">
            <div class="col-md-4 pl-3">
                <div class="profile-section">
                    <div class="left">

                    </div>
                    <div class="right">
                        <p class="name">
                            <strong class="blue-text">{{ exportItem.title }}</strong>
                        </p>
                    </div>
                </div>

                <table class="review-details mt-3">
                    <tbody>
                        <tr>
                            <th scope="row">{{ __('Date') }}</th>
                            <td>
                                <span class="date"><strong>{{ exportItem.date }}</strong></span>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">{{ __('Total Responses') }}</th>
                            <td>
                                <span class="date"><strong>{{ exportItem.totalResponses }}</strong></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <item-buttons
                action-type="primary"
                :secondary-actions="false"
            >
                <div class="d-inline-block align-middle" slot="primary-button">
                    <a href="#" v-on:click="download(exportItem.id)" class="btn btn-primary btn-large">
                        Download <i class="fas fa-eye"></i>
                    </a>
                </div>
            </item-buttons>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import SurveysService from '../../services/surveys-service'

    export default {
        props: ['exportItem'],
        computed: {
        },
        data() {
            return {
            }
        },
        methods: {
            async download(archiveId) {
                const data = await SurveysService.archives.download(archiveId)

                if (data.error) {
                    swal({
                        title: 'Could not download report',
                        text: data.error,
                        type: 'warning',
                        showCloseButton: true,
                        timer: 10000
                    })
                }
            }
        }
    }
</script>
